// Civil Litigation Images
import civilimg1 from "../../assets/Services/civil-litigation/civil-1.jpg";
import civilimg2 from "../../assets/Services/civil-litigation/civil-2.jpg";
import civilimg3 from "../../assets/Services/civil-litigation/civil-3.jpg";
import civilimg4 from "../../assets/Services/civil-litigation/civil-4.jpg";
import civilimg5 from "../../assets/Services/civil-litigation/civil-5.jpg";
import civilimg6 from "../../assets/Services/civil-litigation/civil-6.jpg";
import civilimg7 from "../../assets/Services/civil-litigation/civil-7.jpg";
import civilimg8 from "../../assets/Services/civil-litigation/civil-8.jpg";

// Criminal Litigation Images
import criminalimg1 from "../../assets/Services/criminal-litigation/criminal-1.jpg";
import criminalimg2 from "../../assets/Services/criminal-litigation/criminal-2.jpg";
import criminalimg3 from "../../assets/Services/criminal-litigation/criminal-3.jpg";
import criminalimg4 from "../../assets/Services/criminal-litigation/criminal-4.jpg";
import criminalimg5 from "../../assets/Services/criminal-litigation/criminal-5.jpg";
import criminalimg6 from "../../assets/Services/criminal-litigation/criminal-6.jpg";
import criminalimg7 from "../../assets/Services/criminal-litigation/criminal-7.jpg";
import criminalimg8 from "../../assets/Services/criminal-litigation/criminal-8.jpg";

// Matrimonial Matters Images
import matrimonialimg1 from "../../assets/Services/matrimonial-matters/matrimonial-1.jpg";
import matrimonialimg2 from "../../assets/Services/matrimonial-matters/matrimonial-2.jpg";
import matrimonialimg3 from "../../assets/Services/matrimonial-matters/matrimonial-3.jpg";
import matrimonialimg4 from "../../assets/Services/matrimonial-matters/matrimonial-4.jpg";
import matrimonialimg5 from "../../assets/Services/matrimonial-matters/matrimonial-5.jpg";
import matrimonialimg6 from "../../assets/Services/matrimonial-matters/matrimonial-6.jpg";
import matrimonialimg7 from "../../assets/Services/matrimonial-matters/matrimonial-7.jpg";
import matrimonialimg8 from "../../assets/Services/matrimonial-matters/matrimonial-8.jpg";

// Commercial Matters Images
import commercialimg1 from "../../assets/Services/commercial-law/commercial-1.jpg";
import commercialimg2 from "../../assets/Services/commercial-law/commercial-2.jpg";
import commercialimg3 from "../../assets/Services/commercial-law/commercial-3.jpg";
import commercialimg4 from "../../assets/Services/commercial-law/commercial-4.jpg";
import commercialimg5 from "../../assets/Services/commercial-law/commercial-5.jpg";
import commercialimg6 from "../../assets/Services/commercial-law/commercial-6.jpg";
import commercialimg7 from "../../assets/Services/commercial-law/commercial-7.jpg";
import commercialimg8 from "../../assets/Services/commercial-law/commercial-8.jpg";

// RERA Matters Images
import reraimg1 from "../../assets/Services/rera-matters/rare-1.jpg";
import reraimg2 from "../../assets/Services/rera-matters/rare-2.jpg";
import reraimg3 from "../../assets/Services/rera-matters/rare-3.jpg";
import reraimg4 from "../../assets/Services/rera-matters/rare-4.jpg";
import reraimg5 from "../../assets/Services/rera-matters/rare-5.jpg";
import reraimg6 from "../../assets/Services/rera-matters/rare-6.jpg";
import reraimg7 from "../../assets/Services/rera-matters/rare-7.jpg";
import reraimg8 from "../../assets/Services/rera-matters/rare-8.jpg";

// Cheque Bounce Cases Images
import chequeimg1 from "../../assets/Services/cheque-bounce-cases/cheque-1.jpg";
import chequeimg2 from "../../assets/Services/cheque-bounce-cases/cheque-2.jpg";
import chequeimg3 from "../../assets/Services/cheque-bounce-cases/cheque-3.jpg";
import chequeimg4 from "../../assets/Services/cheque-bounce-cases/cheque-4.jpg";
import chequeimg5 from "../../assets/Services/cheque-bounce-cases/cheque-5.jpg";
import chequeimg6 from "../../assets/Services/cheque-bounce-cases/cheque-6.jpg";
import chequeimg7 from "../../assets/Services/cheque-bounce-cases/cheque-7.jpg";
import chequeimg8 from "../../assets/Services/cheque-bounce-cases/cheque-8.jpg";

// Constitutional Matters Images
import constitutionalimg1 from "../../assets/Services/constitutional-law/constitutional-1.jpg";
import constitutionalimg2 from "../../assets/Services/constitutional-law/constitutional-2.jpg";
import constitutionalimg3 from "../../assets/Services/constitutional-law/constitutional-3.jpg";
import constitutionalimg4 from "../../assets/Services/constitutional-law/constitutional-4.jpg";
import constitutionalimg5 from "../../assets/Services/constitutional-law/constitutional-5.jpg";
import constitutionalimg6 from "../../assets/Services/constitutional-law/constitutional-6.jpg";
import constitutionalimg7 from "../../assets/Services/constitutional-law/constitutional-7.jpg";
import constitutionalimg8 from "../../assets/Services/constitutional-law/constitutional-8.jpg";

// Banking & Finance Matters Images
import bankingimg1 from "../../assets/Services/banking-finance/banking-1.jpg";
import bankingimg2 from "../../assets/Services/banking-finance/banking-2.jpg";
import bankingimg3 from "../../assets/Services/banking-finance/banking-3.jpg";
import bankingimg4 from "../../assets/Services/banking-finance/banking-4.jpg";
import bankingimg5 from "../../assets/Services/banking-finance/banking-5.jpg";
import bankingimg6 from "../../assets/Services/banking-finance/banking-6.jpg";
import bankingimg7 from "../../assets/Services/banking-finance/banking-7.jpg";
import bankingimg8 from "../../assets/Services/banking-finance/banking-8.jpg";

// IBC Matters Images
import ibcimg1 from "../../assets/Services/ibc-matters/ibc-1.jpg";
import ibcimg2 from "../../assets/Services/ibc-matters/ibc-2.jpg";
import ibcimg3 from "../../assets/Services/ibc-matters/ibc-3.jpg";
import ibcimg4 from "../../assets/Services/ibc-matters/ibc-4.jpg";
import ibcimg5 from "../../assets/Services/ibc-matters/ibc-5.jpg";
import ibcimg6 from "../../assets/Services/ibc-matters/ibc-6.jpg";
import ibcimg7 from "../../assets/Services/ibc-matters/ibc-7.jpg";
import ibcimg8 from "../../assets/Services/ibc-matters/ibc-8.jpg";

// Cyber Matters Images
import cyberimg1 from "../../assets/Services/cyber-matters/cyber-1.jpg";
import cyberimg2 from "../../assets/Services/cyber-matters/cyber-2.jpg";
import cyberimg3 from "../../assets/Services/cyber-matters/cyber-3.jpg";
import cyberimg4 from "../../assets/Services/cyber-matters/cyber-4.jpg";
import cyberimg5 from "../../assets/Services/cyber-matters/cyber-5.jpg";
import cyberimg6 from "../../assets/Services/cyber-matters/cyber-6.jpg";
import cyberimg7 from "../../assets/Services/cyber-matters/cyber-7.jpg";
import cyberimg8 from "../../assets/Services/cyber-matters/cyber-8.jpg";

// Environmental Matters Images
import envimg1 from "../../assets/Services/environmental-matters/envirment-1.jpg";
import envimg2 from "../../assets/Services/environmental-matters/envirment-2.jpg";
import envimg3 from "../../assets/Services/environmental-matters/envirment-3.jpg";
import envimg4 from "../../assets/Services/environmental-matters/envirment-4.jpg";
import envimg5 from "../../assets/Services/environmental-matters/envirment-5.jpg";
import envimg6 from "../../assets/Services/environmental-matters/envirment-6.jpg";
import envimg7 from "../../assets/Services/environmental-matters/envirment-7.jpg";
import envimg8 from "../../assets/Services/environmental-matters/envirment-8.jpg";

// Arbitration & Mediation Images
import arbimg1 from "../../assets/Services/arbitration-mediation/arbitration-1.jpg";
import arbimg2 from "../../assets/Services/arbitration-mediation/arbitration-2.jpg";
import arbimg3 from "../../assets/Services/arbitration-mediation/arbitration-3.jpg";
import arbimg4 from "../../assets/Services/arbitration-mediation/arbitration-4.jpg";
import arbimg5 from "../../assets/Services/arbitration-mediation/arbitration-5.jpg";
import arbimg6 from "../../assets/Services/arbitration-mediation/arbitration-6.jpg";
import arbimg7 from "../../assets/Services/arbitration-mediation/arbitration-7.jpg";
import arbimg8 from "../../assets/Services/arbitration-mediation/arbitration-8.jpg";

// Company Matters Images
import cpimg1 from "../../assets/Services/company-matters/company-1.jpg";
import cpimg2 from "../../assets/Services/company-matters/company-2.jpg";
import cpimg3 from "../../assets/Services/company-matters/company-3.jpg";
import cpimg4 from "../../assets/Services/company-matters/company-4.jpg";
import cpimg5 from "../../assets/Services/company-matters/company-5.jpg";
import cpimg6 from "../../assets/Services/company-matters/company-6.jpg";
import cpimg7 from "../../assets/Services/company-matters/company-7.jpg";
import cpimg8 from "../../assets/Services/company-matters/company-8.jpg";

// Human Rights / PILs Images
import humanimg1 from "../../assets/Services/human-rights-pils/humanright-1.jpg";
import humanimg2 from "../../assets/Services/human-rights-pils/humanright-2.jpg";
import humanimg3 from "../../assets/Services/human-rights-pils/humanright-3.jpg";
import humanimg4 from "../../assets/Services/human-rights-pils/humanright-4.jpg";
import humanimg5 from "../../assets/Services/human-rights-pils/humanright-5.jpg";
import humanimg6 from "../../assets/Services/human-rights-pils/humanright-6.jpg";
import humanimg7 from "../../assets/Services/human-rights-pils/humanright-7.jpg";
import humanimg8 from "../../assets/Services/human-rights-pils/humanright-8.jpg";

export const servicesData = [
  {
    id: "civil-cases",
    title: "Civil Cases",
    bannerImage: civilimg2,
    shortDesc:
      "Expert handling of property disputes, contract enforcement, and consumer rights.",
    fullDesc:
      "We provide comprehensive civil litigation services, including property disputes, injunctions, recovery suits, partition suits, specific performance, rent & eviction cases, consumer law, and execution petitions. Our dedicated team ensures legal remedies are pursued efficiently and effectively in all civil matters.",
    icon: "⚖️",
    featureDetails: [
      {
        name: "Property Disputes",
        img: civilimg1,
        desc: "Expert handling of land ownership and title deed conflicts.",
      },
      {
        name: "Injunctions",
        img: civilimg2,
        desc: "Securing immediate court orders to prevent illegal actions.",
      },
      {
        name: "Recovery Suits",
        img: civilimg3,
        desc: "Legal action for recovery of outstanding debts and dues.",
      },
      {
        name: "Partition Suits",
        img: civilimg4,
        desc: "Legal division of ancestral or joint properties among heirs.",
      },
      {
        name: "Specific Performance",
        img: civilimg5,
        desc: "Enforcing contractual obligations through court mandates.",
      },
      {
        name: "Rent & Eviction",
        img: civilimg6,
        desc: "Resolving landlord-tenant disputes and eviction processes.",
      },
      {
        name: "Consumer Law",
        img: civilimg7,
        desc: "Protecting rights against unfair trade practices and services.",
      },
      {
        name: "Execution Petitions",
        img: civilimg8,
        desc: "Implementing court decrees to ensure justice is served.",
      },
    ],
    helmetTitle: "Civil Litigation Services - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Civil Litigation services at Nyaysakti Chambers. Experienced lawyers providing trusted legal solutions in property, contract, and civil disputes.",
    helmetKeywords:
      "Civil Litigation, Nyaysakti, Legal Services, Property Disputes, Contract Disputes, Attorneys",
    helmetnoscript:
      "Please enable JavaScript to view this Civil Litigation service page properly.",
  },
  {
    id: "criminal-cases",
    title: "Criminal Cases",
    bannerImage: criminalimg2,
    shortDesc:
      "Expert defense in bail matters, white-collar crimes, and trial advocacy.",
    fullDesc:
      "We provide strategic criminal defense services ranging from anticipatory bail to representing clients in complex criminal trials. Our expertise covers IPC offenses, white-collar crimes, and appellate advocacy in higher courts.",
    icon: "🏛️",
    featureDetails: [
      {
        name: "Regular Bail",
        img: criminalimg1,
        desc: "Representation for securing release during investigation or trial.",
      },
      {
        name: "Anticipatory Bail",
        img: criminalimg2,
        desc: "Legal protection against potential arrest in non-bailable offences.",
      },
      {
        name: "Trial Advocacy",
        img: criminalimg3,
        desc: "Comprehensive defense throughout the criminal trial process.",
      },
      {
        name: "FIR Quashing",
        img: criminalimg4,
        desc: "Petitions before High Courts to quash meritless criminal proceedings.",
      },
      {
        name: "Criminal Appeals",
        img: criminalimg5,
        desc: "Challenging convictions in Sessions, High Courts & Supreme Court.",
      },
      {
        name: "White Collar Crimes",
        img: criminalimg6,
        desc: "Handling complex corporate fraud and financial investigations.",
      },
      {
        name: "Cyber Crimes",
        img: criminalimg7,
        desc: "Defense in matters of data theft, hacking, and online fraud.",
      },
      {
        name: "Police Custody Help",
        img: criminalimg8,
        desc: "Legal assistance during police interrogation and custody.",
      },
    ],
    helmetTitle: "Criminal Litigation Services - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Criminal Litigation services at Nyaysakti Chambers. Skilled lawyers providing trusted legal solutions in criminal defense and prosecution.",
    helmetKeywords:
      "Criminal Litigation, Nyaysakti, Legal Services, Defense, Prosecution",
    helmetnoscript:
      "Please enable JavaScript to view this Criminal Litigation service page properly.",
  },
  {
    id: "matrimonial-Cases",
    title: "Matrimonial Cases",
    bannerImage: matrimonialimg3,
    shortDesc:
      "Sensitive handling of divorce, child custody, and family settlements.",
    fullDesc:
      "We handle sensitive family issues with utmost confidentiality. Our services include mutual consent divorce, contested divorce, maintenance (Section 125 CrPC), and complex child custody disputes.",
    icon: "🏠",
    featureDetails: [
      {
        name: "Mutual Divorce",
        img: matrimonialimg1,
        desc: "Fast-track dissolution of marriage with mutual agreement.",
      },
      {
        name: "Contested Divorce",
        img: matrimonialimg2,
        desc: "Strong representation in complex disputed divorce cases.",
      },
      {
        name: "Child Custody",
        img: matrimonialimg3,
        desc: "Protecting parental rights and ensuring the child's welfare.",
      },
      {
        name: "Alimony Matters",
        img: matrimonialimg4,
        desc: "Legal support for fair financial maintenance and settlements.",
      },
      {
        name: "Domestic Violence",
        img: matrimonialimg5,
        desc: "Protection orders and litigation under the DV Act.",
      },
      {
        name: "Annulment",
        img: matrimonialimg6,
        desc: "Legal petitions for declaring a marriage null and void.",
      },
      {
        name: "Restitution of Rights",
        img: matrimonialimg7,
        desc: "Legal steps for the reconciliation of separated spouses.",
      },
      {
        name: "Family Counseling",
        img: matrimonialimg8,
        desc: "Mediation services to resolve family disputes amicably.",
      },
    ],
    helmetTitle: "Matrimonial Matters - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Matrimonial Matters services at Nyaysakti Chambers. Experienced lawyers providing trusted legal guidance in family and matrimonial disputes.",
    helmetKeywords:
      "Matrimonial Matters, Nyaysakti, Family Law, Legal Services, Divorce, Child Custody",
    helmetnoscript:
      "Please enable JavaScript to view this Matrimonial Matters service page properly.",
  },
  {
    id: "domestic-violence",
    title: "Domestic Violence",
    bannerImage: commercialimg2,
    shortDesc:
      "Specialized legal advice for domestic violence cases and protection orders.",
    fullDesc:
      "We provide expert legal support for victims of domestic violence. Our services include filing protection orders, representing clients in domestic violence proceedings, and ensuring their safety and rights are protected.",
    icon: "🛡️",
    featureDetails: [
      {
        name: "NCLT Litigation",
        img: commercialimg1,
        desc: "Representation in company law and insolvency tribunals.",
      },
      {
        name: "Contract Disputes",
        img: commercialimg2,
        desc: "Resolution of breaches and commercial agreement conflicts.",
      },
      {
        name: "Intellectual Property",
        img: commercialimg3,
        desc: "Protecting trademarks, copyrights, and patents.",
      },
      {
        name: "Shareholder Rights",
        img: commercialimg4,
        desc: "Protecting interests in internal corporate disputes.",
      },
      {
        name: "Mergers & JV",
        img: commercialimg5,
        desc: "Legal guidance for business acquisitions and joint ventures.",
      },
      {
        name: "Recovery of Dues",
        img: commercialimg6,
        desc: "Commercial suits for recovering business outstanding payments.",
      },
      {
        name: "Compliance Audit",
        img: commercialimg7,
        desc: "Ensuring business operations follow statutory regulations.",
      },
      {
        name: "Trade Secrets",
        img: commercialimg8,
        desc: "Legal protection for confidential business information.",
      },
    ],
    helmetTitle: "Commercial Law Services - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Commercial Law services at Nyaysakti Chambers. Expert lawyers providing trusted guidance on business, contracts, and corporate matters.",
    helmetKeywords:
      "Commercial Law, Nyaysakti, Business Law, Corporate Law, Legal Services, Contracts",
    helmetnoscript:
      "Please enable JavaScript to view this Commercial Law service page properly.",
  },
  {
    id: "partnership-matters",
    title: "Partnership Matters",
    bannerImage: reraimg3,
    shortDesc:
      "Protecting home-buyer rights and real estate developer compliance.",
    fullDesc:
      "We represent buyers and developers before the Real Estate Regulatory Authority (RERA). Our services include filing complaints for possession delays and refunds.",
    icon: "🏗️",
    featureDetails: [
      {
        name: "Possession Delay",
        img: reraimg1,
        desc: "Legal action for builders failing to deliver on time.",
      },
      {
        name: "Refund Claims",
        img: reraimg2,
        desc: "Seeking full refunds with interest for project cancellations.",
      },
      {
        name: "Builder Complaints",
        img: reraimg3,
        desc: "Filing formal grievances before RERA authorities.",
      },
      {
        name: "Project Registration",
        img: reraimg4,
        desc: "Assistance in RERA compliance for new developers.",
      },
      {
        name: "Agreement Review",
        img: reraimg5,
        desc: "Legal vetting of Builder-Buyer agreements.",
      },
      {
        name: "Structural Defects",
        img: reraimg6,
        desc: "Compensation for poor construction quality within 5 years.",
      },
      {
        name: "RERA Execution",
        img: reraimg7,
        desc: "Implementing RERA orders through court execution.",
      },
      {
        name: "Adjudicating Officer",
        img: reraimg8,
        desc: "Representation in compensation and damage claims.",
      },
    ],
    helmetTitle: "RERA Matters - Nyaysakti Chambers",
    helmetDescription:
      "Explore our RERA Matters services at Nyaysakti Chambers. Experienced lawyers providing trusted legal guidance on real estate disputes and compliance.",
    helmetKeywords:
      "RERA, Nyaysakti, Real Estate Law, Property Disputes, Legal Services, Compliance",
    helmetnoscript:
      "Please enable JavaScript to view this RERA Matters service page properly.",
  },
  {
    id: "recovery-of-money",
    title: "Recovery of Money",
    bannerImage: chequeimg2,
    shortDesc: "Fast-track legal action under Section 138 of the NI Act.",
    fullDesc:
      "We provide robust legal services for the recovery of dues through Negotiable Instruments Act proceedings, focusing on quick settlement.",
    icon: "🖋️",
    featureDetails: [
      {
        name: "Legal Notice",
        img: chequeimg1,
        desc: "Drafting the mandatory 15-day notice for cheque dishonor.",
      },
      {
        name: "Sec 138 Complaint",
        img: chequeimg2,
        desc: "Filing criminal complaints in Magistrate courts.",
      },
      {
        name: "Summary Suits",
        img: chequeimg3,
        desc: "Civil recovery suits alongside criminal proceedings.",
      },
      {
        name: "Evidence Filing",
        img: chequeimg4,
        desc: "Submitting bank memos and original documents as proof.",
      },
      {
        name: "Interim Compensation",
        img: chequeimg5,
        desc: "Securing 20% of cheque amount during the trial.",
      },
      {
        name: "Mediation",
        img: chequeimg6,
        desc: "Settling cheque disputes through court-led mediation.",
      },
      {
        name: "Defense Counsel",
        img: chequeimg7,
        desc: "Representing clients falsely accused in cheque cases.",
      },
      {
        name: "Appeals",
        img: chequeimg8,
        desc: "Filing or defending appeals against cheque case judgments.",
      },
    ],
    helmetTitle: "Cheque Bounce Cases - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Cheque Bounce Cases services at Nyaysakti Chambers. Skilled lawyers providing trusted legal solutions for cheque dishonor and banking disputes.",
    helmetKeywords:
      "Cheque Bounce Cases, Nyaysakti, Banking Law, Legal Services, Dishonored Cheque, Litigation",
    helmetnoscript:
      "Please enable JavaScript to view this Cheque Bounce Cases service page properly.",
  },
  {
    id: "constitutional-law",
    title: "Constitutional Matters",
    bannerImage: constitutionalimg2,
    shortDesc:
      "Protection of fundamental rights through Writ Petitions and PILs.",
    fullDesc:
      "Our firm specializes in Constitutional law, representing individuals and entities in Writ Petitions before High Courts and the Supreme Court to protect fundamental rights and challenge arbitrary state actions.",
    icon: "📜",
    featureDetails: [
      {
        name: "Writ of Habeas Corpus",
        img: constitutionalimg1,
        desc: "Legal action against unlawful detention or illegal imprisonment.",
      },
      {
        name: "Writ of Mandamus",
        img: constitutionalimg2,
        desc: "Court orders directing public officials to perform their legal duties.",
      },
      {
        name: "Writ of Certiorari",
        img: constitutionalimg3,
        desc: "Quashing orders passed by inferior courts or judicial authorities.",
      },
      {
        name: "PIL Advocacy",
        img: constitutionalimg4,
        desc: "Filing Public Interest Litigations for social and legal reform.",
      },
      {
        name: "Fundamental Rights",
        img: constitutionalimg5,
        desc: "Legal protection against violation of basic human rights by State.",
      },
      {
        name: "Service Matters",
        img: constitutionalimg6,
        desc: "Constitutional remedies for government employment disputes.",
      },
      {
        name: "Quo-Warranto",
        img: constitutionalimg7,
        desc: "Challenging the right of a person to hold a public office.",
      },
      {
        name: "Election Petitions",
        img: constitutionalimg8,
        desc: "Legal challenges regarding the validity of election results.",
      },
    ],
    helmetTitle: "Constitutional Matters - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Constitutional Matters services at Nyaysakti Chambers. Experienced lawyers providing guidance on constitutional rights, writs, and legal remedies.",
    helmetKeywords:
      "Constitutional Matters, Nyaysakti, Legal Services, Constitutional Law, Writs, Rights",
    helmetnoscript:
      "Please enable JavaScript to view this Constitutional Matters service page properly.",
  },
  {
    id: "banking-finance",
    title: "Banking & Finance",
    bannerImage: bankingimg2,
    shortDesc:
      "Legal solutions for DRT cases, loan defaults, and financial disputes.",
    fullDesc:
      "Our team handles complex banking litigation, including representation before the Debt Recovery Tribunal (DRT). We advise on SARFAESI Act proceedings and financial regulatory compliance.",
    icon: "💰",
    featureDetails: [
      {
        name: "DRT Litigation",
        img: bankingimg1,
        desc: "Representation in Debt Recovery Tribunal for loan matters.",
      },
      {
        name: "SARFAESI Act",
        img: bankingimg2,
        desc: "Legal defense against bank notices for property attachment.",
      },
      {
        name: "Loan Recovery",
        img: bankingimg3,
        desc: "Strategic legal action for recovery of commercial bank loans.",
      },
      {
        name: "Bank Fraud Defense",
        img: bankingimg4,
        desc: "Advocacy in matters involving financial scams and irregularities.",
      },
      {
        name: "Credit Disputes",
        img: bankingimg5,
        desc: "Resolving issues related to credit scores and faulty reporting.",
      },
      {
        name: "Arbitration in Finance",
        img: bankingimg6,
        desc: "Settling banking disputes through private arbitration routes.",
      },
      {
        name: "Mortgage Disputes",
        img: bankingimg7,
        desc: "Handling legal issues related to pledged assets and titles.",
      },
      {
        name: "NPA Management",
        img: bankingimg8,
        desc: "Legal guidance on restructuring Non-Performing Assets.",
      },
    ],
    helmetTitle: "Banking & Finance - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Banking & Finance services at Nyaysakti Chambers. Expert lawyers providing trusted legal guidance on banking regulations, loans, and financial disputes.",
    helmetKeywords:
      "Banking Law, Finance Law, Nyaysakti, Legal Services, Loans, Financial Disputes",
    helmetnoscript:
      "Please enable JavaScript to view this Banking & Finance service page properly.",
  },
  {
    id: "negotiable-instrument-act-cases",
    title: "Negotiable Instrument Act Cases",
    bannerImage: ibcimg1,
    shortDesc:
      "Insolvency and Bankruptcy proceedings for corporate and individual debt.",
    fullDesc:
      "We provide end-to-end services under the Insolvency and Bankruptcy Code (IBC). This includes filing for insolvency and representing creditors in resolution processes.",
    icon: "📉",
    featureDetails: [
      {
        name: "CIRP Proceedings",
        img: ibcimg1,
        desc: "Initiating Corporate Insolvency Resolution Process.",
      },
      {
        name: "NCLT Representation",
        img: ibcimg2,
        desc: "Handling insolvency petitions before the Company Law Tribunal.",
      },
      {
        name: "Operational Creditors",
        img: ibcimg3,
        desc: "Legal help for vendors to recover dues from insolvent firms.",
      },
      {
        name: "Financial Creditors",
        img: ibcimg4,
        desc: "Representing banks in the Committee of Creditors (CoC).",
      },
      {
        name: "Liquidation Help",
        img: ibcimg5,
        desc: "Legal guidance through the asset liquidation process.",
      },
      {
        name: "Personal Guarantors",
        img: ibcimg6,
        desc: "Insolvency proceedings against individual guarantors of loans.",
      },
      {
        name: "Resolution Plans",
        img: ibcimg7,
        desc: "Vetting and drafting effective corporate resolution strategies.",
      },
      {
        name: "Cross Border IBC",
        img: ibcimg8,
        desc: "Handling insolvency matters involving international assets.",
      },
    ],
    helmetTitle: "IBC Matters - Nyaysakti Chambers",
    helmetDescription:
      "Explore our IBC Matters services at Nyaysakti Chambers. Experienced lawyers providing expert guidance on insolvency, bankruptcy, and corporate restructuring.",
    helmetKeywords:
      "IBC Matters, Nyaysakti, Insolvency Law, Bankruptcy, Legal Services, Corporate Restructuring",
    helmetnoscript:
      "Please enable JavaScript to view this IBC Matters service page properly.",
  },
  {
    id: "cyber-cases",
    title: "Cyber Matters",
    bannerImage: cyberimg2 ,
    shortDesc: "Legal defense against cyber crimes and data breaches.",
    fullDesc:
      "With the rise of digital crimes, we offer specialized services in Cyber Law. We handle cases related to data theft, online fraud, and violations under the IT Act.",
    icon: "💻",
    featureDetails: [
      {
        name: "Data Theft",
        img: cyberimg1,
        desc: "Litigation against unauthorized access and stealing of data.",
      },
      {
        name: "Online Fraud",
        img: cyberimg2,
        desc: "Legal action against phishing, vishing, and financial scams.",
      },
      {
        name: "Cyber Defamation",
        img: cyberimg3,
        desc: "Tackling reputation damage through social media or websites.",
      },
      {
        name: "IT Act Violations",
        img: cyberimg4,
        desc: "Defense in criminal cases under various sections of IT Act.",
      },
      {
        name: "Digital Signatures",
        img: cyberimg5,
        desc: "Resolving disputes related to forged or misused e-signatures.",
      },
      {
        name: "E-Commerce Law",
        img: cyberimg6,
        desc: "Legal compliance for online businesses and marketplaces.",
      },
      {
        name: "Privacy Compliance",
        img: cyberimg7,
        desc: "Ensuring data protection laws are followed by organizations.",
      },
      {
        name: "Identity Theft",
        img: cyberimg8,
        desc: "Criminal action against misuse of personal identity online.",
      },
    ],
    helmetTitle: "Cyber Matters - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Cyber Matters services at Nyaysakti Chambers. Expert lawyers providing trusted legal guidance on cybercrime, data protection, and IT compliance.",
    helmetKeywords:
      "Cyber Law, Nyaysakti, Cyber Matters, Legal Services, Data Protection, IT Compliance",
    helmetnoscript:
      "Please enable JavaScript to view this Cyber Matters service page properly.",
  },
  {
    id: "environmental-matters",
    title: "Environmental Matters",
    bannerImage: envimg2,
    shortDesc: "Litigation before the NGT for environmental protection.",
    fullDesc:
      "We represent clients in environmental disputes before the National Green Tribunal (NGT), including pollution control compliance and ecological protection.",
    icon: "🌿",
    featureDetails: [
      {
        name: "NGT Appeals",
        img: envimg1,
        desc: "Challenging orders passed by environmental authorities.",
      },
      {
        name: "Pollution Control",
        img: envimg2,
        desc: "Legal help regarding State & Central Pollution Board notices.",
      },
      {
        name: "Forest Clearances",
        img: envimg3,
        desc: "Guidance on obtaining ecological and forest usage permits.",
      },
      {
        name: "Waste Management",
        img: envimg4,
        desc: "Compliance with plastic, medical, and hazardous waste rules.",
      },
      {
        name: "Coastal Regulation",
        img: envimg5,
        desc: "Matters related to construction and activity in CRZ areas.",
      },
      {
        name: "Noise Pollution",
        img: envimg6,
        desc: "Legal action against violation of silence zones and norms.",
      },
      {
        name: "Mining Laws",
        img: envimg7,
        desc: "Environmental litigation related to sand and stone mining.",
      },
      {
        name: "Public Health PILs",
        img: envimg8,
        desc: "Litigation for cleaner air and water for the community.",
      },
    ],
    helmetTitle: "Environmental law - Nyaysakti Chambers",
    helmetDescription:
      "Environmental law (consultant, clearances) ",
    helmetKeywords:
      "Environmental Law, Nyaysakti, Legal Services, Compliance, Sustainability, Environmental Matters",
    helmetnoscript:
      "Please enable JavaScript to view this Environmental Matters service page properly.",
  },
  {
    id: "divorce-cases",
    title: "Divorce Cases",
    bannerImage: arbimg2,
    shortDesc: "Legal representation in matrimonial and divorce proceedings.",
    fullDesc:
      "We assist clients in resolving disputes outside the traditional courtroom through Arbitration and Mediation, ensuring cost-effective resolutions.",
    icon: "🤝",
    featureDetails: [
      {
        name: "Domestic Arbitration",
        img: arbimg1,
        desc: "Handling arbitration proceedings under the Indian Arbitration Act.",
      },
      {
        name: "International ADR",
        img: arbimg2,
        desc: "Representing clients in cross-border commercial disputes.",
      },
      {
        name: "Court Mediation",
        img: arbimg3,
        desc: "Resolving litigation through court-appointed expert mediators.",
      },
      {
        name: "Conciliation",
        img: arbimg4,
        desc: "Amicable settlement of disputes through a neutral third party.",
      },
      {
        name: "Award Enforcement",
        img: arbimg5,
        desc: "Legal action to execute arbitration awards through courts.",
      },
      {
        name: "Award Challenges",
        img: arbimg6,
        desc: "Filing or defending petitions to set aside unfair awards.",
      },
      {
        name: "Business Mediation",
        img: arbimg7,
        desc: "Specialized mediation for business and partnership conflicts.",
      },
      {
        name: "Family Settlements",
        img: arbimg8,
        desc: "Using mediation to resolve sensitive family or estate matters.",
      },
    ],
    helmetTitle: "Arbitration & Mediation - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Arbitration & Mediation services at Nyaysakti Chambers. Expert lawyers providing trusted guidance on dispute resolution, arbitration, and mediation proceedings.",
    helmetKeywords:
      "Arbitration, Mediation, Nyaysakti, Legal Services, Dispute Resolution, Lawyers",
    helmetnoscript:
      "Please enable JavaScript to view this Arbitration & Mediation service page properly.",
  },
  {
    id: "property-disputes",
    title: "Property Disputes",
    bannerImage: cpimg3,
    shortDesc: "Legal representation in property-related disputes.",
    fullDesc:
      "From startup incorporation to secretarial audits, we handle all legal aspects of company management and MCA compliance.",
    icon: "🏢",
    featureDetails: [
      {
        name: "Incorporation",
        img: cpimg1,
        desc: "Formation of Private Limited, LLP, and OPC companies.",
      },
      {
        name: "ROC Compliance",
        img: cpimg2,
        desc: "Managing annual filings and records with the Registrar.",
      },
      {
        name: "Shareholder Rights",
        img: cpimg3,
        desc: "Legal representation in internal management conflicts.",
      },
      {
        name: "M&A Due Diligence",
        img: cpimg4,
        desc: "Evaluating legal risks during company acquisitions.",
      },
      {
        name: "Company Winding Up",
        img: cpimg5,
        desc: "Assisting in the legal closure and dissolution of companies.",
      },
      {
        name: "Director Liability",
        img: cpimg6,
        desc: "Advocacy in matters of directorial duties and liabilities.",
      },
      {
        name: "Secretarial Audit",
        img: cpimg7,
        desc: "Ensuring company records meet all government regulations.",
      },
      {
        name: "MoA & AoA Drafting",
        img: cpimg8,
        desc: "Creating Charter documents for new business firms.",
      },
    ],
    helmetTitle: "Company Matters - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Company Matters services at Nyaysakti Chambers. Experienced lawyers providing trusted legal guidance on corporate compliance, incorporation, and business regulations.",
    helmetKeywords:
      "Company Law, Nyaysakti, Legal Services, Corporate Compliance, Business Law, Incorporation",
    helmetnoscript:
      "Please enable JavaScript to view this Company Matters service page properly.",
  },
  {
    id: "human-rights-pils",
    title: "Human Rights / PILs",
    bannerImage: humanimg2,
    shortDesc:
      "Advocating for social justice and protection of civil liberties.",
    fullDesc:
      "Our firm is dedicated to social causes through PILs, addressing human rights violations and systemic administrative failures.",
    icon: "📢",
    featureDetails: [
      {
        name: "Civil Liberty",
        img: humanimg1,
        desc: "Protecting citizens against arbitrary state or police action.",
      },
      {
        name: "Environmental PILs",
        img: humanimg2,
        desc: "Litigation for community rights to clean air and water.",
      },
      {
        name: "Prisoner Rights",
        img: humanimg3,
        desc: "Advocating for humane treatment and legal aid for inmates.",
      },
      {
        name: "Women Empowerment",
        img: humanimg4,
        desc: "Legal support for gender equality and protection from bias.",
      },
      {
        name: "Social Reform",
        img: humanimg5,
        desc: "Challenging outdated laws for the betterment of society.",
      },
      {
        name: "Child Advocacy",
        img: humanimg6,
        desc: "Protecting children from labor and ensuring right to education.",
      },
      {
        name: "RTI Petitions",
        img: humanimg7,
        desc: "Using RTI as a tool to ensure government transparency.",
      },
      {
        name: "Equality Suits",
        img: humanimg8,
        desc: "Fighting against discrimination in public and private sectors.",
      },
    ],
    helmetTitle: "Human Rights / PILs - Nyaysakti Chambers",
    helmetDescription:
      "Explore our Human Rights and PIL services at Nyaysakti Chambers. Expert lawyers providing guidance on public interest litigation and protection of fundamental rights.",
    helmetKeywords:
      "Human Rights, PIL, Nyaysakti, Legal Services, Public Interest Litigation, Fundamental Rights",
    helmetnoscript:
      "Please enable JavaScript to view this Human Rights / PILs service page properly.",
  },
  {
  id: "commercial-disputes",
  title: "Commercial Disputes",
  bannerImage: commercialimg3,
  shortDesc:
    "Specialized legal services for business conflicts, partnership issues, and contract enforcement.",
  fullDesc:
    "We provide expert guidance and representation in commercial disputes, including recovery of money, partnership matters, contract breaches, and company-related issues. Our team ensures effective resolution through litigation, arbitration, or mediation.",
  icon: "💼",
  featureDetails: [
    {
      name: "Contract Disputes",
      img: commercialimg1,
      desc: "Resolving breaches and conflicts in business contracts efficiently.",
    },
    {
      name: "Recovery of Money",
      img: commercialimg2,
      desc: "Legal action to recover outstanding dues from business dealings.",
    },
    {
      name: "Partnership Matters",
      img: commercialimg3,
      desc: "Handling disputes among business partners with legal expertise.",
    },
    {
      name: "Company Related Issues",
      img: commercialimg4,
      desc: "Corporate compliance, internal conflicts, and company regulations.",
    },
    {
      name: "NCLT Representation",
      img: commercialimg5,
      desc: "Litigation and representation before the National Company Law Tribunal.",
    },
    {
      name: "Intellectual Property",
      img: commercialimg6,
      desc: "Protecting business trademarks, copyrights, and patents.",
    },
    {
      name: "Compliance Audit",
      img: commercialimg7,
      desc: "Ensuring statutory compliance in all commercial operations.",
    },
    {
      name: "Trade Secrets",
      img: commercialimg8,
      desc: "Safeguarding confidential business information legally.",
    },
  ],
  helmetTitle: "Commercial Disputes - Nyaysakti Chambers",
  helmetDescription:
    "Explore our Commercial Disputes services at Nyaysakti Chambers. Experienced lawyers providing trusted guidance on business, partnerships, and contract disputes.",
  helmetKeywords:
    "Commercial Disputes, Nyaysakti, Legal Services, Business Law, Partnerships, Contract Disputes",
  helmetnoscript:
    "Please enable JavaScript to view this Commercial Disputes service page properly.",
},
{
  id: "company-related-issue",
  title: "Company Related Issue",
  bannerImage: cpimg3,
  shortDesc:
    "Comprehensive legal services for corporate compliance, partnership disputes, and company management.",
  fullDesc:
    "We provide expert guidance and representation in company-related issues, including incorporation, internal conflicts, shareholder disputes, M&A due diligence, and director liability. Our team ensures businesses operate legally and efficiently.",
  icon: "🏢",
  featureDetails: [
    {
      name: "Incorporation",
      img: cpimg1,
      desc: "Formation of Private Limited, LLP, and OPC companies.",
    },
    {
      name: "ROC Compliance",
      img: cpimg2,
      desc: "Managing annual filings and records with the Registrar.",
    },
    {
      name: "Shareholder Rights",
      img: cpimg3,
      desc: "Legal representation in internal company conflicts.",
    },
    {
      name: "M&A Due Diligence",
      img: cpimg4,
      desc: "Evaluating legal risks during mergers and acquisitions.",
    },
    {
      name: "Company Winding Up",
      img: cpimg5,
      desc: "Assisting in the legal closure and dissolution of companies.",
    },
    {
      name: "Director Liability",
      img: cpimg6,
      desc: "Advocacy in matters of directors' duties and liabilities.",
    },
    {
      name: "Secretarial Audit",
      img: cpimg7,
      desc: "Ensuring company records meet all statutory requirements.",
    },
    {
      name: "MoA & AoA Drafting",
      img: cpimg8,
      desc: "Drafting Memorandum and Articles of Association for businesses.",
    },
  ],
  helmetTitle: "Company Related Issue - Nyaysakti Chambers",
  helmetDescription:
    "Explore our Company Related Issue services at Nyaysakti Chambers. Expert lawyers providing trusted guidance on corporate compliance, partnerships, and company management.",
  helmetKeywords:
    "Company Related Issue, Nyaysakti, Legal Services, Corporate Compliance, Partnerships, Business Law",
  helmetnoscript:
    "Please enable JavaScript to view this Company Related Issue service page properly.",
},
{
  id: "bail-trial",
  title: "Bail Trial",
  bannerImage: criminalimg4,
  shortDesc:
    "Expert legal representation during bail hearings and trials.",
  fullDesc:
    "We provide specialized legal services for bail trials, including regular bail, anticipatory bail, and representation during hearings. Our team ensures your rights are protected and bail procedures are handled efficiently.",
  icon: "⚖️",
  featureDetails: [
    {
      name: "Regular Bail",
      img: criminalimg1,
      desc: "Representation for securing release during investigation or trial.",
    },
    {
      name: "Anticipatory Bail",
      img: criminalimg2,
      desc: "Legal protection against potential arrest in non-bailable offences.",
    },
    {
      name: "Bail Hearing Representation",
      img: criminalimg3,
      desc: "Expert advocacy during bail hearings in court.",
    },
    {
      name: "FIR Review & Advice",
      img: criminalimg4,
      desc: "Legal guidance before filing or responding to FIRs.",
    },
    {
      name: "Legal Strategy",
      img: criminalimg5,
      desc: "Comprehensive planning to maximize chances of bail approval.",
    },
    {
      name: "Court Liaison",
      img: criminalimg6,
      desc: "Coordination with courts for timely bail applications.",
    },
  ],
  helmetTitle: "Bail Trial - Nyaysakti Chambers",
  helmetDescription:
    "Explore our Bail Trial services at Nyaysakti Chambers. Skilled lawyers providing trusted representation during bail hearings and trials.",
  helmetKeywords:
    "Bail Trial, Nyaysakti, Legal Services, Criminal Law, Bail, Defense",
  helmetnoscript:
    "Please enable JavaScript to view this Bail Trial service page properly.",
}

];
